import { Pipe, PipeTransform } from '@angular/core';
import { LocalizationService } from '../services/localization.service';
import { Labels } from 'src/interfaces/enums.model';

@Pipe({
    name: 'labelTranslate',
    pure: true,
    standalone: false
})
export class LabelTranslatePipe implements PipeTransform {

  constructor(private localization: LocalizationService) {}

  transform(label: Labels): string {
    return this.localization.getLabelTranslation(label);
  }

}